import {
	DocumentReference,
	getCountFromServer,
	Query,
	QuerySnapshot,
} from 'firebase/firestore';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { fromRef } from './from-ref';
import { SnapDataOptions, snapToData } from './snap-to-data';

/**
 * Observable stream of a document's data. Emits when the document changes.
 */
export function docData<T>(
	ref: DocumentReference<T>,
	options: SnapDataOptions = {},
): Observable<T | undefined> {
	return fromRef(ref).pipe(map((snap) => snapToData(snap, options)));
}

/**
 * Observable stream of query results mapped to document data. Emits when the query changes.
 */
export function collectionData<T>(
	query: Query<T>,
	options: SnapDataOptions = {},
): Observable<T[]> {
	return fromRef(query).pipe(
		map((snap: QuerySnapshot<T>) =>
			snap.docs.map((docSnap) => snapToData(docSnap, options) as T),
		),
	);
}

/**
 * Observable that emits the aggregate count for a query once, then completes.
 */
export function collectionCount(query: Query): Observable<number> {
	return from(getCountFromServer(query)).pipe(
		map((snap) => snap.data().count),
	);
}
